<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

export default {

  name: 'TransitionWrapper',

  props: {
    appear: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },

    appearDelay: {
      type: [Number, String],
      default: 0
    },

    beforeAppearTransition: {
      type: Function,
      default: null
    },
    appearTransition: {
      type: Function,
      default: null
    },
    beforeEnterTransition: {
      type: Function,
      default: null
    },
    enterTransition: {
      type: Function,
      default: null
    },
    beforeLeaveTransition: {
      type: Function,
      default: null
    },
    leaveTransition: {
      type: Function,
      default: null
    }
  },

  methods: {
    beforeAppear (el) {
      if (!this.$children.length) return

      const child = this.$children[0]

      if (child.hasOwnProperty('beforeAppear')) {
        child.beforeAppear(child.$el)
      } else if (child.hasOwnProperty('beforeEnter')) {
        child.beforeEnter(child.$el)
      } else if (this.beforeAppearTransition) {
        this.beforeAppearTransition(child.$el)
      }
    },

    appear_ (el, done) {
      if (!this.$children.length) return

      const child = this.$children[0]

      if (child.hasOwnProperty('appear')) {

        this.$emit('transition-start')
        child.appear(child.$el, () => {
          this.$emit('transition-end')
          done()
        }, { delay: this.appearDelay })

      } else if (child.hasOwnProperty('enter')) {

        this.$emit('transition-start')
        child.enter(child.$el, () => {
          this.$emit('transition-end')
          done()
        })

      } else if (this.appearTransition) {
        this.appearTransition(child.$el, done)
      } else {
        done()
      }
    },

    beforeEnter (el) {
      if (!this.$children.length) return

      const child = this.$children[0]

      if (child.hasOwnProperty('beforeEnter')) {
        child.beforeEnter(child.$el)
      } else if (this.beforeEnterTransition) {
        this.beforeEnterTransition(child.$el)
      }
    },

    enter (el, done) {
      if (!this.$children.length) return

      const child = this.$children[0]

      if (child.hasOwnProperty('enter')) {

        this.$emit('transition-start')
        child.enter(child.$el, () => {
          this.$emit('transition-end')
          done()
        })

      } else if (this.enterTransition) {
        this.enterTransition(child.$el, done)
      } else {
        done()
      }
    },

    beforeLeave (el) {
      if (!this.$children.length) return

      const child = this.$children[0]

      if (child.hasOwnProperty('beforeLeave')) {
        child.beforeLeave(child.$el)
      } else if (this.beforeLeaveTransition) {
        this.beforeLeaveTransition(child.$el)
      }
    },

    leave (el, done) {
      if (!this.$children.length) return

      const child = this.$children[0]

      if (child.hasOwnProperty('leave')) {

        this.$emit('transition-start')
        child.leave(child.$el, () => {
          this.$emit('transition-end')
          done()
        })

      } else if (this.leaveTransition) {
        this.leaveTransition(child.$el, done)
      } else {
        done()
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

transition(
  :appear="appear"
  :mode="mode"
  :name="name"
  :css="false"
  @beforeAppear="beforeAppear"
  @appear="appear_"
  @beforeEnter="beforeEnter"
  @enter="enter"
  @beforeLeave="beforeLeave"
  @leave="leave"
  )
  slot

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>



</style>



// WEBPACK FOOTER //
// transition-wrapper.vue?f707f34a